/**
 * Above Category — scroll reveal and accordion close helper (loaded defer from layout/theme.liquid).
 *
 * Reveal: elements carrying data-ac-reveal get .is-in once 12% of them has entered the viewport (CSS in
 * assets/ac-ui.css, section 12, does the fade and rise; the hidden state is gated on html.js, which the inline
 * script in the layout sets before first paint, so without JavaScript nothing is ever hidden). Elements already in
 * view when the observer first runs are marked .ac-reveal--instant so they appear without a transition: nothing
 * above the fold animates on load. Honours prefers-reduced-motion by revealing everything at once.
 *
 * Accordion: <details class="ac-accordion"> animates its panel with grid-template-rows (ac-ui.css, section 11).
 * Opening needs no script; closing would snap because the browser hides the content the moment `open` is removed,
 * so a click on the summary of an open item is intercepted, .is-closing collapses the row, and `open` is removed
 * when that transition ends. Enter / Space on a focused summary dispatch the same click, so keyboard use is unchanged.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  function reveal() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-ac-reveal]'));
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('ac-reveal--instant', 'is-in'); });
      return;
    }

    var first = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (first) el.classList.add('ac-reveal--instant');
        el.classList.add('is-in');
        io.unobserve(el);
      });
      first = false;
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach(function (el) { io.observe(el); });

    // The theme editor re-renders sections in place; new reveal targets are observed as they appear.
    if (document.documentElement.classList.contains('shopify-design-mode') && 'MutationObserver' in window) {
      new MutationObserver(function () {
        document.querySelectorAll('[data-ac-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---- Accordion close ---- */
  function accordions() {
    document.addEventListener('click', function (event) {
      var summary = event.target.closest && event.target.closest('details.ac-accordion > .ac-accordion__summary');
      if (!summary) return;
      var details = summary.parentElement;
      var panel = details.querySelector(':scope > .ac-accordion__panel');
      if (!details.open || !panel || reduce) return; // opening, or no animated panel: native behaviour
      if (details.classList.contains('is-closing')) { event.preventDefault(); return; }

      event.preventDefault();
      details.classList.add('is-closing');
      details.classList.remove('ac-accordion--preopen');

      var done = function (e) {
        if (e && e.target !== panel) return;
        panel.removeEventListener('transitionend', done);
        clearTimeout(timer);
        details.open = false;
        details.classList.remove('is-closing');
      };
      panel.addEventListener('transitionend', done);
      var timer = setTimeout(done, 600); // safety net if transitionend never fires
    });

    // Once an item has been opened by hand, the no-animation-on-load flag is spent.
    document.addEventListener('toggle', function (event) {
      var d = event.target;
      if (d && d.classList && d.classList.contains('ac-accordion') && d.open) d.classList.remove('ac-accordion--preopen');
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); accordions(); });
  } else {
    reveal();
    accordions();
  }
})();
